var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetCrypto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 281,
    height: 400,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#reset_crypto_svg__clip0_2658_57772)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.269 197.979l1.075 3.967c1.09 4.127-11.238 15.179-21.149 22.13l-3.293 2.311.905 3.46L86.3 315.01c7.771 29.423 29.632 53.075 63.199 68.405a181.034 181.034 0 0048.648 14.366l2.719.324 2.211-1.626a180.917 180.917 0 0035.203-36.513c21.627-29.908 28.949-61.266 21.178-90.69l-23.403-88.607-4.005-.383c-12.061-1.159-26.613-5.309-27.704-9.439l-1.001-3.79-63.766-.994-53.31 31.916z",
    fill: "url(#reset_crypto_svg__paint0_linear_2658_57772)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.87 398.115l-61.29-232.053 63.768 1.001 1 3.788c1.082 4.097 15.463 8.262 27.705 9.439l4.004.382 23.406 88.617c7.771 29.422.447 60.783-21.18 90.691a181.291 181.291 0 01-35.202 36.509l-2.211 1.626z",
    fill: "#000",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.65 311.11l-46.296 12.227c-3.189.843-5.685.679-7.64-.499-1.981-1.19-3.379-3.395-4.263-6.742l-9.222-34.916c-1.398-5.295.684-9.719 5.57-11.835l-3.171-12.005a33.49 33.49 0 01-1.078-12.241 23.872 23.872 0 013.205-9.693 23.063 23.063 0 016.483-6.956 26.888 26.888 0 018.749-4.048 24.77 24.77 0 0118.687 2.082 23.959 23.959 0 017.571 6.87 33.574 33.574 0 015.108 11.187l3.146 11.912a9.058 9.058 0 016.762 1.215 10.686 10.686 0 013.943 6.351l9.222 34.916c.884 3.347.762 5.954-.378 7.968-1.118 1.989-3.207 3.364-6.398 4.207zm-34.968-12.023a2.134 2.134 0 00-1.318 1 2.159 2.159 0 00-.219 1.64l.056.209c.071.275.196.533.367.76a2.144 2.144 0 002.273.777l3.725-.984.423 1.601a2.153 2.153 0 002.64 1.537l.904-.239a2.162 2.162 0 001.537-2.64l-3.218-12.183a9.135 9.135 0 003.34-3.992 8.153 8.153 0 00.36-5.55 8.6 8.6 0 00-4-5.274 8.598 8.598 0 00-6.561-.874 8.594 8.594 0 00-6.147 10.561 8.142 8.142 0 003.052 4.648 9.124 9.124 0 004.875 1.823l1.637 6.196-3.726.984zm-10.558-66.862c-10.095 2.666-14.569 11.134-11.673 22.101l3.405 12.891 32.583-8.606-3.443-12.955c-2.885-10.924-10.883-16.07-20.872-13.431zm13.699 53.372a2.397 2.397 0 01-2.89-2.919 2.404 2.404 0 012.435-1.812 2.398 2.398 0 011.965 3.607 2.378 2.378 0 01-1.51 1.124z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.258 26.506a4.155 4.155 0 013.69-6.06c.674 0 1.307.163 1.87.447-.276.678-.549 1.367-.818 2.067a1.938 1.938 0 00-1.051-.312 1.947 1.947 0 00-.247 3.88c-.24.7-.472 1.405-.694 2.115a4.167 4.167 0 01-1.077-.41l-3.585 3.584 2.326 2.328-1.699 1.699-2.327-2.328-.904.905 2.114 2.114-1.7 1.699-3.717-3.909 7.82-7.819z",
    fill: "#7DB1A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.89 26.547c.814.021 1.583-.44 1.888-1.223.391-1.005-.132-2.146-1.167-2.55a2.023 2.023 0 00-1.9.224 10.289 10.289 0 00-1.308-1.834 4.314 4.314 0 014.007-.443c2.204.858 3.317 3.288 2.484 5.426a4.03 4.03 0 01-1.139 1.602l4.417 9.613-4.989 2.252-.757-1.62 1.283-.587-.449-1.197-.927.45-1.016-2.218 2.349-1.028-2.143-4.681a4.334 4.334 0 01-.613.028 10.09 10.09 0 00-.02-2.214z",
    fill: "#FB9300"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.304 30.672a4.155 4.155 0 01.628-5.843 4.128 4.128 0 012.514-.915c-.031.737-.003 1.474.079 2.206a1.938 1.938 0 00-1.211.424 1.953 1.953 0 002.104 3.263c.26.685.568 1.353.924 1.996-.352.17-.72.29-1.095.355l-.831 6.443 1.432.159-.257 2.389-1.432-.158-.136 1.272 2.971.319-.256 2.39-5.347-.712 1.47-12.396a4.143 4.143 0 01-1.557-1.192z",
    fill: "#523B5D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.543 7.21c5.438 0 9.863 4.424 9.863 9.864 0 5.438-4.425 9.862-9.863 9.862-5.439 0-9.863-4.424-9.863-9.862 0-5.44 4.424-9.864 9.863-9.864zm-.001 22.13c6.763 0 12.267-5.503 12.267-12.267 0-6.763-5.504-12.266-12.267-12.266-6.764 0-12.267 5.503-12.267 12.266 0 6.764 5.503 12.266 12.267 12.266z",
    fill: "#B3E0D0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.32 4.173L111.923 0l-3.516 6.008h-2.679l-.837 2.804 16.909 2.803 4.52-7.442z",
    fill: "#F9B6A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.596 6.308h-5.19v-.6h5.19v.6z",
    fill: "#CC395D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.346 372.397l-3.605 27.937 16.822-5.407-6.91-3.605 3.305-21.028-9.612 2.103zM20.279 370.294l-3.005 27.637 16.222-4.506-8.11-4.206 3.604-18.925H20.28z",
    fill: "#3A3B39"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.468 211.883l9.416 80.566a53.769 53.769 0 01-.57 16.217l-12.651 67.035h-14.42L70.463 300l-24.05-68.491v63.207c0 3.514-.344 7.02-1.028 10.467l-13.992 70.518h-15.62l3.605-70.294s-22.23-72.096-13.219-111.148l81.31 17.624z",
    fill: "#E73A5E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.866 64.121s31.943 53.536 29.239 73.362c-2.703 19.826-41.154-4.206-41.154-4.206l11.915-69.156z",
    fill: "#0080A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.831 19.026h3.002l7.41 17.423-2.204 1.401 1.25 7.134a2.273 2.273 0 01-2.083 2.658l-4.674.322L59.23 59.63H40.404l7.41-18.975-.198-21.629h11.215z",
    fill: "#F9B6A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.833 42.056l11.014 3.405 6.245 8.31-6.245 2.904-6.608-5.807 1.602-3.806-6.008-3.204v-1.802z",
    fill: "#F7A8A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.09 53.772l7.775 10.35-12.516 1.365-4.106-8.812 8.848-2.903z",
    fill: "#0080A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.319 4.173l-5.407 7.442s13.818 28.72 17.423 58.078c0 0-74.5-14.019-89.72-12.817C33.396 58.078-6.657 59.679.953 203.47l86.515 8.412L89.47 93.725s72.897 17.623 71.695-17.223c-1.201-34.847-34.846-72.329-34.846-72.329z",
    fill: "#00AEC8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.334 69.693l8.211 1.201-9.022-6.773.811 5.572z",
    fill: "#0080A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.79 37.25h2.604s-.799-15.22-3.402-16.222c0 0 11.145 1.142 12.016-4.806.949-6.476-6.411-8.212-9.265-3.856 0 0-15.168.05-12.965 7.66 0 0 .05 11.816 3.456 22.03l3.574-1.986 3.982-2.82z",
    fill: "#523B5D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.986 37.762c-.721-1.104-1.475-2.24-2.512-2.88-1.037-.641-2.443-.642-3.241.381-.9 1.153-.647 3.119.195 4.333.84 1.213 2.105 1.858 3.318 2.46",
    fill: "#F9B6A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.527 39.85a.3.3 0 00.183-.539l-3.404-2.603a.3.3 0 00-.365.477l3.405 2.604a.299.299 0 00.181.062z",
    fill: "#CC395D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.833 29.34a1.201 1.201 0 112.402-.002 1.201 1.201 0 01-2.402.001zM58.262 27.838h6.174a.45.45 0 000-.902h-6.174a.45.45 0 000 .902z",
    fill: "#3A3B39"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.467 211.883H4.008l.6-8.056 82.859 8.056zM46.412 231.509H25.785l20.627 7.21v-7.21z",
    fill: "#CC395D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.98 94.069L74.952 90.92l15.32 10.829.71-7.681z",
    fill: "#0080A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.531 47.964h-4.104l3.828 1.402",
    fill: "#CC395D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.95 26.553a1.953 1.953 0 001.952-1.953c0-.69-.36-1.293-.9-1.64-.236-.918.036-1.608.817-2.067a4.152 4.152 0 01-1.87 7.863c-.324 0-.637-.043-.94-.113-.392-.71-.439-1.414.694-2.115.081.01.162.025.247.025z",
    fill: "#7DB1A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.405 21.164c.858.073 1.294.688 1.307 1.833-.299.21-.542.503-.683.866-.392 1.005.13 2.147 1.166 2.55.23.09.465.128.696.134.846.778.538 1.494.02 2.214a4.37 4.37 0 01-1.515-.295c-2.204-.858-3.316-3.288-2.484-5.427a4.045 4.045 0 011.493-1.875z",
    fill: "#FB9300"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.767 29.585c.84-.676.971-1.906.295-2.745a1.941 1.941 0 00-1.535-.719c-.527-.907-.604-1.663-.079-2.206a4.144 4.144 0 013.329 1.542 4.156 4.156 0 01-.628 5.843 4.136 4.136 0 01-.805.503c-.76-.482-1.067-1.15-.924-1.995.121-.062.238-.134.347-.223z",
    fill: "#523B5D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "reset_crypto_svg__paint0_linear_2658_57772",
    x1: 139.579,
    y1: 166.063,
    x2: 210.733,
    y2: 435.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BCC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B9C15"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "reset_crypto_svg__clip0_2658_57772"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h281v400H0z"
  })))));
}
export default SvgResetCrypto;